const HEALTHY_STATUSES = ['operational', 'ok', 'okay', 'functional', 'working', 'healthy'];

export default {
  methods: {
    hasPeripheralStatus(peripheral) {
      return !!(peripheral && typeof peripheral.status === 'string' && peripheral.status.trim());
    },
    isPeripheralFaulty(peripheral) {
      if (!this.hasPeripheralStatus(peripheral)) return false;
      return !HEALTHY_STATUSES.includes(peripheral.status.trim().toLowerCase());
    },
    peripheralStatusLabel(peripheral) {
      if (!this.hasPeripheralStatus(peripheral)) return 'N/A';
      return this.isPeripheralFaulty(peripheral) ? 'Faulty' : 'Operational';
    },
  },
}
